import { IAPIPreference, IPreference } from '../interface/IPreference'

export const preferenceResponseTransformer = (
  apiResponse: IAPIPreference,
): IPreference => ({
  calendarDivision: apiResponse.calendar_division,
  onlinePaymentEnabled: apiResponse.online_payment_enabled,
  absencesAutoCreateHolidays: apiResponse.absences_auto_create_holidays,
  facebookPages:
    apiResponse.facebook_pages?.map(details => ({
      externalBusinessId: details.external_business_id,
      externalBusinessName: details.external_business_name,
      businessManagerId: details.business_manager_id,
      status: details.status,
    })) || [],
  isShopifyEnabled: apiResponse.is_shopify_enabled,
  shopifyUrl: apiResponse.shopify_url,
  isWooCommerceEnabled: apiResponse.is_woo_commerce_enabled,
  woocommerceApiUrl: apiResponse.woocommerce_api_url,
  googleTagManagerContainerId: apiResponse.google_tag_manager_container_id,
})

export const reversePreferenceTransformer = (
  data: IPreference,
): IAPIPreference => ({
  calendar_division: data.calendarDivision,
  online_payment_enabled: data.onlinePaymentEnabled,
  absences_auto_create_holidays: data.absencesAutoCreateHolidays,
  facebook_pages:
    data.facebookPages?.map(details => ({
      external_business_name: details.externalBusinessName,
      external_business_id: details.externalBusinessId,
      business_manager_id: details.businessManagerId,
      status: details.status,
    })) || [],
  is_shopify_enabled: data.isShopifyEnabled,
  shopify_url: data.shopifyUrl,
  is_woo_commerce_enabled: data.isWooCommerceEnabled,
  woocommerce_api_url: data.woocommerceApiUrl,
  google_tag_manager_container_id: data.googleTagManagerContainerId,
})
